import React, { useState, useEffect } from 'react'

import AWS from 'aws-sdk'

import { makeStyles } from '@material-ui/core/styles'
// import Tooltip from '@material-ui/core/Tooltip'
import Divider from '@material-ui/core/Divider'
import Slider from '@material-ui/core/Slider'
import Checkbox from '@material-ui/core/Checkbox'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import RemoveIcon from '@material-ui/icons/Remove'
import CloseIcon from '@material-ui/icons/Close'
import { DashOutlined, LineOutlined } from '@ant-design/icons'

import { CompactPicker } from 'react-color'

import './drawingProperties.css'

function DrawingProperties(props) {
  const [colorGeometry, setColorGeometry] = useState({
    hsl: {
      h: 0,
      s: 0,
      l: 0.2,
      a: 1,
    },
    hex: '#333333',
    rgb: {
      r: 51,
      g: 51,
      b: 51,
      a: 1,
    },
    hsv: {
      h: 0,
      s: 0,
      v: 0.2,
      a: 1,
    },
    oldHue: 0,
  })

  const [colorBorder, setColorBorder] = useState({
    hsl: {
      h: 0,
      s: 0,
      l: 0.2,
      a: 1,
    },
    hex: '#333333',
    rgb: {
      r: 51,
      g: 51,
      b: 51,
      a: 1,
    },
    hsv: {
      h: 0,
      s: 0,
      v: 0.2,
      a: 1,
    },
    oldHue: 0,
  })

  const [geometryOpacity, setGeometryOpacity] = useState(50)
  const [borderOpacity, setBorderOpacity] = useState(100)
  const [geometryWidth, setGeometryWidth] = useState(3)
  const [dotted, setDotted] = useState(true)
  const [solid, setSolid] = useState(false)

  const defaultColor = {
    hsl: {
      h: 0,
      s: 0,
      l: 0.2,
      a: 1,
    },
    hex: '#333333',
    rgb: {
      r: 51,
      g: 51,
      b: 51,
      a: 1,
    },
    hsv: {
      h: 0,
      s: 0,
      v: 0.2,
      a: 1,
    },
    oldHue: 0,
  }

  useEffect(() => {
    props.geometry.properties.colorCode
      ? typeof props.geometry.properties.colorCode === 'string'
        ? setColorGeometry(JSON.parse(props.geometry.properties.colorCode))
        : setColorGeometry(props.geometry.properties.colorCode)
      : setColorGeometry(defaultColor)
    props.geometry.properties.colorCodeB
      ? typeof props.geometry.properties.colorCodeB === 'string'
        ? setColorBorder(JSON.parse(props.geometry.properties.colorCodeB))
        : setColorBorder(props.geometry.properties.colorCodeB)
      : setColorBorder(defaultColor)
    props.geometry.properties.opacity || props.geometry.properties.opacity === 0
      ? setGeometryOpacity(props.geometry.properties.opacity * 100)
      : props.geometry.geometry.type === 'LineString'
      ? setGeometryOpacity(100)
      : setGeometryOpacity(50)
    props.geometry.properties['stroke-opacity'] || props.geometry.properties['stroke-opacity'] === 0
      ? setBorderOpacity(props.geometry.properties['stroke-opacity'] * 100)
      : setBorderOpacity(100)
    props.geometry.properties['stroke-width']
      ? setGeometryWidth(props.geometry.properties['stroke-width'])
      : setGeometryWidth(3)
    props.geometry.properties.dottedLine
      ? props.geometry.properties.dottedLine[0] === 0
        ? setDotted(false)
        : setDotted(true)
      : setDotted(true)
    props.geometry.properties.dottedLine
      ? props.geometry.properties.dottedLine[0] === 0
        ? setSolid(true)
        : setSolid(false)
      : setSolid(false)
  }, [props.propertiesClick])

  const useStyles = makeStyles({
    root: {
      color: `${colorGeometry.hex}`,
      backgroundImage: `linear-gradient(to right, ${colorGeometry.hex}1A ,${colorGeometry.hex}80, ${colorGeometry.hex})`,
      height: 6,
      width: '95%',
      padding: 0,
      border: '0.5px solid #ccc',
      borderRadius: 4,
      margin: 'auto',
      marginTop: '5px',
      '& .MuiSlider-thumb': {
        height: 18,
        width: 18,
        backgroundColor: 'currentColor',
        border: '1.5px solid #ccc',
        marginTop: -6,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
          boxShadow: 'inherit',
        },
      },
      '& .MuiSlider-rail': {
        height: 6,
        opacity: 0,
      },
      '& .MuiSlider-track': {
        height: 6,
        opacity: 0,
      },
      '& .MuiSlider-valueLabel': {
        left: 'calc(-50% + 0px)',
        marginLeft: '0px !important',
        '& *': {
          background: '#ccc',
          color: '#ffffff',
        },
      },
      '& .MuiSlider-mark': {
        width: 1,
        height: 6,
        borderRadius: 4,
      },
    },
    areaBorder: {
      color: `${colorBorder.hex}`,
      backgroundImage: `linear-gradient(to right, ${colorBorder.hex}1A ,${colorBorder.hex}80, ${colorBorder.hex})`,
      height: 6,
      width: '95%',
      padding: 0,
      border: '1px solid #ccc',
      borderRadius: 4,
      margin: 'auto',
      marginTop: '5px',
      '& .MuiSlider-thumb': {
        height: 18,
        width: 18,
        backgroundColor: 'currentColor',
        border: '1.5px solid #ccc',
        marginTop: -6,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
          boxShadow: 'inherit',
        },
      },
      '& .MuiSlider-rail': {
        height: 6,
        opacity: 0,
      },
      '& .MuiSlider-track': {
        height: 6,
        opacity: 0,
      },
      '& .MuiSlider-valueLabel': {
        left: 'calc(-50% + 0px)',
        marginLeft: '0px !important',
        '& *': {
          background: '#ccc',
          color: '#ffffff',
        },
      },
      '& .MuiSlider-mark': {
        width: 5,
        height: 6,
        borderRadius: 4,
        marginLeft: -5,
        color: '#ffffff80',
      },
    },
    thickness: {
      color: `${colorGeometry.hex}`,
      backgroundColor: 'currentColor',
      height: 6,
      width: '95%',
      padding: 0,
      border: '0.5px solid #ccc',
      borderRadius: 4,
      margin: 'auto',
      marginTop: '5px',
      '& .MuiSlider-thumb': {
        height: 18,
        width: 18,
        backgroundColor: 'currentColor',
        border: '1.5px solid #ccc',
        marginTop: -6,
        marginLeft: -12,
        '&:focus, &:hover, &$active': {
          boxShadow: 'inherit',
        },
      },
      '& .MuiSlider-rail': {
        height: 6,
        opacity: 0,
      },
      '& .MuiSlider-track': {
        height: 6,
        opacity: 0,
      },
      '& .MuiSlider-valueLabel': {
        left: 'calc(-50% + 0px)',
        marginLeft: '0px !important',
        '& *': {
          background: '#ccc',
          color: '#ffffff',
        },
      },
      '& .MuiSlider-mark': {
        width: 5,
        height: 6,
        borderRadius: 4,
        marginLeft: -5,
        color: '#ffffff80',
      },
    },
  })

  const classes = useStyles()

  const handleChangeOpacity = (event, newValue) => {
    setGeometryOpacity(newValue)
  }

  const pointProperties = (
    <div className="info-container" style={{ padding: '10px', display: 'flex', flexFlow: 'column' }}>
      <label className="gm-coordinates-title" style={{ marginTop: '-5px', marginBottom: '5px' }}>
        Color
      </label>
      <div className="dp-color-pick-container">
        <CompactPicker
          color={colorGeometry}
          onChangeComplete={(color) => {
            setColorGeometry(color)
            props.changeGeometry(color.rgb, geometryOpacity, color)
          }}
        />
        <div className="dp-color-pick" style={{ background: `${colorGeometry.hex}` }} />
      </div>
      <label className="gm-coordinates-title" style={{ marginTop: '5px' }}>
        Opacity
      </label>
      <Slider
        className={classes.root}
        track={false}
        valueLabelDisplay="auto"
        value={geometryOpacity}
        onChange={handleChangeOpacity}
        onChangeCommitted={() => props.changeGeometry(colorGeometry.rgb, geometryOpacity, colorGeometry)}
      />
    </div>
  )

  const lineProperties = (
    <div className="info-container" style={{ padding: '10px', display: 'flex', flexFlow: 'column' }}>
      <label className="gm-coordinates-title" style={{ marginTop: '-5px', marginBottom: '5px' }}>
        Color
      </label>
      <div className="dp-color-pick-container">
        <CompactPicker
          color={colorGeometry}
          onChangeComplete={(color) => {
            setColorGeometry(color)
            props.changeGeometryLine(color.rgb, geometryOpacity, geometryWidth, color, dotted)
          }}
        />
        <div className="dp-color-pick" style={{ background: `${colorGeometry.hex}` }} />
      </div>
      <label className="gm-coordinates-title" style={{ marginTop: '5px' }}>
        Opacity
      </label>
      <Slider
        className={classes.root}
        track={false}
        valueLabelDisplay="auto"
        value={geometryOpacity}
        onChange={handleChangeOpacity}
        onChangeCommitted={() =>
          props.changeGeometryLine(colorGeometry.rgb, geometryOpacity, geometryWidth, colorGeometry, dotted)
        }
      />
      <label className="gm-coordinates-title" style={{ marginTop: '5px' }}>
        Thickness
      </label>
      <Slider
        value={geometryWidth}
        className={classes.thickness}
        valueLabelDisplay="auto"
        step={1}
        marks
        min={1}
        max={5}
        onChange={(evt, val) => setGeometryWidth(val)}
        onChangeCommitted={() =>
          props.changeGeometryLine(colorGeometry.rgb, geometryOpacity, geometryWidth, colorGeometry, dotted)
        }
      />
      <label className="gm-coordinates-title" style={{ marginTop: '5px', marginBottom: '5px' }}>
        Border Type
      </label>
      <div style={{ display: 'flex', width: 'fit-content', margin: ' auto' }}>
        <Checkbox
          color="primary"
          size="small"
          checked={dotted}
          onChange={(e) => {
            !dotted ? setDotted(e.target.checked) : null
            setSolid(false)
            props.changeGeometryLine(colorGeometry.rgb, geometryOpacity, geometryWidth, colorGeometry, true)
          }}
          style={{ height: '20px', width: '20px' }}
          icon={
            <RadioButtonUncheckedIcon
              style={{
                color:
                  colorGeometry.hex === '#ffffff' || colorGeometry.hex === '#FFFFFF'
                    ? '#cccccc'
                    : `${colorGeometry.hex}`,
              }}
            />
          }
          checkedIcon={
            <RadioButtonCheckedIcon
              style={{
                color:
                  colorGeometry.hex === '#ffffff' || colorGeometry.hex === '#FFFFFF'
                    ? '#cccccc'
                    : `${colorGeometry.hex}`,
              }}
            />
          }
        />
        <DashOutlined
          style={{
            fontSize: '20px',
            marginLeft: '2.5px',
            marginRight: '60px',
            color:
              colorGeometry.hex === '#ffffff' || colorGeometry.hex === '#FFFFFF' ? '#cccccc' : `${colorGeometry.hex}`,
          }}
        />
        <Checkbox
          color="primary"
          size="small"
          checked={solid}
          onChange={(e) => {
            !solid ? setSolid(e.target.checked) : null
            setDotted(false)
            props.changeGeometryLine(colorGeometry.rgb, geometryOpacity, geometryWidth, colorGeometry, false)
          }}
          style={{ height: '20px', width: '20px' }}
          icon={
            <RadioButtonUncheckedIcon
              style={{
                color:
                  colorGeometry.hex === '#ffffff' || colorGeometry.hex === '#FFFFFF'
                    ? '#cccccc'
                    : `${colorGeometry.hex}`,
              }}
            />
          }
          checkedIcon={
            <RadioButtonCheckedIcon
              style={{
                color:
                  colorGeometry.hex === '#ffffff' || colorGeometry.hex === '#FFFFFF'
                    ? '#cccccc'
                    : `${colorGeometry.hex}`,
              }}
            />
          }
        />
        <LineOutlined
          style={{
            fontSize: '20px',
            marginLeft: '2.5px',
            color:
              colorGeometry.hex === '#ffffff' || colorGeometry.hex === '#FFFFFF' ? '#cccccc' : `${colorGeometry.hex}`,
          }}
        />
      </div>
    </div>
  )

  const polygonProperties = (
    <div className="info-container" style={{ padding: '10px', display: 'flex', flexFlow: 'column' }}>
      <label className="gm-coordinates-title" style={{ marginTop: '-5px', marginBottom: '5px' }}>
        Area Color
      </label>
      <div className="dp-color-pick-container">
        <CompactPicker
          color={colorGeometry}
          onChangeComplete={(color) => {
            setColorGeometry(color)
            props.changeGeometryPolygon(
              color.rgb,
              geometryOpacity,
              borderOpacity,
              geometryWidth,
              colorBorder.rgb,
              color,
              colorBorder,
              dotted,
            )
          }}
        />
        <div className="dp-color-pick" style={{ background: `${colorGeometry.hex}` }} />
      </div>
      <label className="gm-coordinates-title" style={{ marginTop: '5px' }}>
        Area Opacity
      </label>
      <Slider
        className={classes.root}
        track={false}
        valueLabelDisplay="auto"
        value={geometryOpacity}
        onChange={handleChangeOpacity}
        onChangeCommitted={() =>
          props.changeGeometryPolygon(
            colorGeometry.rgb,
            geometryOpacity,
            borderOpacity,
            geometryWidth,
            colorBorder.rgb,
            colorGeometry,
            colorBorder,
            dotted,
          )
        }
      />

      <Divider style={{ margin: '15px auto 15px auto' }} />

      <label className="gm-coordinates-title" style={{ marginTop: '-5px', marginBottom: '5px' }}>
        Border Color
      </label>

      <div className="dp-color-pick-container">
        <CompactPicker
          color={colorBorder}
          onChangeComplete={(color) => {
            setColorBorder(color)
            props.changeGeometryPolygon(
              colorGeometry.rgb,
              geometryOpacity,
              borderOpacity,
              geometryWidth,
              color.rgb,
              colorGeometry,
              color,
              dotted,
            )
          }}
        />
        <div className="dp-color-pick" style={{ background: `${colorBorder.hex}` }} />
      </div>
      <label className="gm-coordinates-title" style={{ marginTop: '5px' }}>
        Border Opacity
      </label>
      <Slider
        className={classes.areaBorder}
        track={false}
        valueLabelDisplay="auto"
        value={borderOpacity}
        onChange={(evt, val) => setBorderOpacity(val)}
        onChangeCommitted={() =>
          props.changeGeometryPolygon(
            colorGeometry.rgb,
            geometryOpacity,
            borderOpacity,
            geometryWidth,
            colorBorder.rgb,
            colorGeometry,
            colorBorder,
            dotted,
          )
        }
      />
      <label className="gm-coordinates-title" style={{ marginTop: '5px' }}>
        Border Thickness
      </label>
      <Slider
        value={geometryWidth}
        className={classes.areaBorder}
        valueLabelDisplay="auto"
        step={1}
        marks
        min={1}
        max={5}
        onChange={(evt, val) => setGeometryWidth(val)}
        onChangeCommitted={() =>
          props.changeGeometryPolygon(
            colorGeometry.rgb,
            geometryOpacity,
            borderOpacity,
            geometryWidth,
            colorBorder.rgb,
            colorGeometry,
            colorBorder,
            dotted,
          )
        }
      />
      <label className="gm-coordinates-title" style={{ marginTop: '5px', marginBottom: '5px' }}>
        Border Type
      </label>
      <div style={{ display: 'flex', width: 'fit-content', margin: 'auto' }}>
        <Checkbox
          color="primary"
          size="small"
          checked={dotted}
          onChange={(e) => {
            !dotted ? setDotted(e.target.checked) : null
            setSolid(false)
            props.changeGeometryPolygon(
              colorGeometry.rgb,
              geometryOpacity,
              borderOpacity,
              geometryWidth,
              colorBorder.rgb,
              colorGeometry,
              colorBorder,
              true,
            )
          }}
          style={{ height: '20px', width: '20px' }}
          icon={
            <RadioButtonUncheckedIcon
              style={{
                color:
                  colorBorder.hex === '#ffffff' || colorBorder.hex === '#FFFFFF' ? '#cccccc' : `${colorBorder.hex}`,
              }}
            />
          }
          checkedIcon={
            <RadioButtonCheckedIcon
              style={{
                color:
                  colorBorder.hex === '#ffffff' || colorBorder.hex === '#FFFFFF' ? '#cccccc' : `${colorBorder.hex}`,
              }}
            />
          }
        />
        <DashOutlined
          style={{
            fontSize: '20px',
            marginLeft: '2.5px',
            marginRight: '60px',
            color: colorBorder.hex === '#ffffff' || colorBorder.hex === '#FFFFFF' ? '#cccccc' : `${colorBorder.hex}`,
          }}
        />

        <Checkbox
          color="primary"
          size="small"
          checked={solid}
          onChange={(e) => {
            !solid ? setSolid(e.target.checked) : null
            setDotted(false)
            props.changeGeometryPolygon(
              colorGeometry.rgb,
              geometryOpacity,
              borderOpacity,
              geometryWidth,
              colorBorder.rgb,
              colorGeometry,
              colorBorder,
              false,
            )
          }}
          style={{ height: '20px', width: '20px' }}
          icon={
            <RadioButtonUncheckedIcon
              style={{
                color:
                  colorBorder.hex === '#ffffff' || colorBorder.hex === '#FFFFFF' ? '#cccccc' : `${colorBorder.hex}`,
              }}
            />
          }
          checkedIcon={
            <RadioButtonCheckedIcon
              style={{
                color:
                  colorBorder.hex === '#ffffff' || colorBorder.hex === '#FFFFFF' ? '#cccccc' : `${colorBorder.hex}`,
              }}
            />
          }
        />
        <LineOutlined
          style={{
            fontSize: '20px',
            marginLeft: '2.5px',
            color: colorBorder.hex === '#ffffff' || colorBorder.hex === '#FFFFFF' ? '#cccccc' : `${colorBorder.hex}`,
          }}
        />
      </div>
    </div>
  )

  return (
    <div
      className="on-click"
      style={{
        visibility: `${props.propertiesClick.visibility}`,
        top: '10px',
        right: '10px',
        zIndex: '3',
        marginBottom: '50px',
        width: '340px',
        pointerEvents: props.propertiesClick.visibility === 'hidden' ? 'none' : 'auto',
        opacity: props.propertiesClick.visibility === 'hidden' ? '0' : '1',
      }}
    >
      <div style={{ color: 'black', height: '20px', display: 'flex' }}>
        <label className="on-click-title">
          {props.geometry.geometry.type === 'Point'
            ? 'Point Styles'
            : props.geometry.geometry.type === 'LineString'
            ? 'Line Styles'
            : 'Polygon Styles'}
        </label>
        <CloseIcon
          style={{
            fontSize: '19px',
            position: 'relative',
            margin: 'auto',
            marginRight: '5px',
            cursor: 'pointer',
          }}
          onClick={() => {
            props.setPropertiesClick({ visibility: 'hidden', x: -100, y: -100 })
            props.setSelectedGeometry()
          }}
        />
      </div>
      {props.geometry.geometry.type === 'Point'
        ? pointProperties
        : props.geometry.geometry.type === 'LineString'
        ? lineProperties
        : props.geometry.geometry.type === 'Polygon'
        ? polygonProperties
        : null}
    </div>
  )
}

DrawingProperties.defaultProps = {
  geometry: {
    geometry: {
      type: '',
      coordinates: [],
    },
    properties: {},
  },
}

export default DrawingProperties
